import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, HostBinding } from '@angular/core';
import { RouteElementService } from 'dbweb-core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CTRL_LOGIN } from '../const';
import { IRouterState } from '../router-state';
import { HomeTabfunctionService } from './home-tabfunction.service';
import { TabsService } from './tabs.service';
@Component({
	selector: 'common-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	animations: [
		trigger('routerTransition', [
			transition(':enter, * => -1', []),
			transition(':increment', [
				style({ position: 'relative', overflow: 'hidden' }),
				query(':enter, :leave', style({ position: 'absolute', width: '100%', height: '100%' }), {
					optional: true
				}),
				group([
					query(
						':enter',
						[
							style({ transform: 'translateX(-100%)' }),
							animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
						],
						{ optional: true }
					),
					query(
						':leave',
						[
							style({ transform: 'translateX(0%)' }),
							animate('0.5s ease-in-out', style({ transform: 'translateX(100%)' }))
						],
						{ optional: true }
					)
				])
			]),
			transition(':decrement', [
				style({ position: 'relative', overflow: 'hidden' }),
				query(':enter, :leave', style({ position: 'absolute', width: '100%', height: '100%' }), {
					optional: true
				}),
				group([
					query(
						':enter',
						[
							style({ transform: 'translateX(100%)' }),
							animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
						],
						{ optional: true }
					),
					query(
						':leave',
						[
							style({ transform: 'translateX(0%)' }),
							animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
						],
						{ optional: true }
					)
				])
			])
		])
	]
})
export class HomeComponent implements OnInit, OnDestroy {
	@HostBinding('class.c-home') hostClass = true;
	subs: Subscription[] = [];
	@ViewChild('tabNav', { static: true })
	tabNavs: ElementRef;
	category: any;
	copystate: Boolean = false;
	constructor(
		private routerEle: RouteElementService,
		public eles: RouteElementService,
		private tabFun: HomeTabfunctionService,
		public tabs: TabsService
	) {
		this.subs.push(
			this.routerEle.currentElementListen
				.pipe(filter(ele => ele && ele.element && ele.element.Controller !== CTRL_LOGIN))
				.subscribe(ele => {
					let state = ele.state as IRouterState;
					if (!state) {
						let key = ele.url;
						const arr = key.split('/');
						// åè½ç±»çï¼éè¦å»é¤å­è·¯ç±ä½ä¸ºkeyï¼é²æ­¢åºç°å¤ä½çtab
						if (!ele.element.Bill && arr.length > 5) {
							key = arr.slice(0, 5).join('/');
							// éè¦å¤çquery
							const queryArr = arr[arr.length - 1].split('?');
							if (queryArr.length > 1) {
								key += '?' + queryArr[1];
							}
						}
						state = {
							url: ele.urlObj,
							key: key,
							title: ele.element.title()
						};
					}
					this.tabs.activeTab(state);
				})
		);
		this.category = this.tabFun.category;
	}
	ngOnInit() {}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}
}
